(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["industry-food-brands-solution"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('food-brand-solution-form');
    var success = document.querySelector('[data-form-success]');

    if (success) {
      window.setTimeout(function () {
        success.scrollIntoView({ block: 'center', behavior: 'smooth' });
        success.focus({ preventScroll: true });
      }, 120);
    }

    if (!form) {
      return;
    }

    form.addEventListener('submit', function () {
      if (form.checkValidity && !form.checkValidity()) {
        return;
      }

      var button = form.querySelector('[data-submit-button]');
      var label = form.querySelector('[data-submit-label]');
      var status = form.querySelector('[data-submit-status]');

      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      }

      if (label && button) {
        label.textContent = button.getAttribute('data-sending-label') || 'Sending...';
      }

      if (status) {
        status.hidden = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["industry-solution-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-industry-form-success]').forEach(function (success) {
      window.setTimeout(function () {
        success.scrollIntoView({ block: 'center', behavior: 'smooth' });
        success.focus({ preventScroll: true });
      }, 120);
    });

    document.querySelectorAll('.industry-solution__form').forEach(function (form) {
      form.addEventListener('submit', function () {
        if (form.checkValidity && !form.checkValidity()) {
          return;
        }

        var button = form.querySelector('[data-submit-button]');
        var label = form.querySelector('[data-submit-label]');
        var status = form.querySelector('[data-submit-status]');

        if (button) {
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
        }

        if (label && button) {
          label.textContent = button.getAttribute('data-sending-label') || 'Sending...';
        }

        if (status) {
          status.hidden = false;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
